import { translate } from 'react-jhipster';

export const livingStateToChinese = state => translate(`userManagement.livingStateValue.${state}`);
export const wxStateToChinese = state => translate(`userManagement.wxbindedValue.${state}`);
